/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import { Calendar } from 'react-calendar';
import moment from 'moment';
import { createUrl } from '../../../../redux/helper/CreateQuery';

function ViewCustomerFilterModal({
    viewFilterModal, setViewFilterModal, selected, setselected, viewCustomerFilter, setViewCustomerFilter, handleFilter, filterValue, setfilterValue, SetSuccessMessage,
}) {
    const dateRef = useRef();
    const [selectedType, setselectedType] = useState('gst_invoice_date');
    const toggleState = {
        gst_start_date: false,
        gst_end_date: false,
        ar_start_date: false,
        ar_end_date: false,
    };

    const [toggle, settoggle] = useState(toggleState);

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const handleClear = () => {
        setViewCustomerFilter({
            gst_invoice_date: [],
            ar_date: [],
        });
        setselected({
            gst_start_date: '',
            gst_end_date: '',
            ar_start_date: '',
            ar_end_date: '',
        });
        setfilterValue('');
        // handleIndentReports();
        setViewFilterModal(false);
        SetSuccessMessage('Filters cleared Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
    };

    const handleDate = (val, key) => {
        const state = key === 'gst_start_date' ? 'gst_end_date' : 'gst_start_date';
        if (key === 'start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        handleToggle(state);
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        settoggle(toggleState);
    };

    const generateUrl = (val) => {
        let final = '';
        if (selected.start_date !== '' && selected.end_date !== '') {
            final += `&GST_INVOICE_DATE=${moment(selected.start_date).format('DD-MM-YYYY')},${moment(selected.end_date).format('DD-MM-YYYY')}`;
        }
        if (selected.order_start_date !== '' && selected.order_end_date !== '') {
            final += `&TRX_DATE=${moment(selected.order_start_date).format('DD-MM-YYYY')},${moment(selected.order_end_date).format('DD-MM-YYYY')}`;
        }
        if (val === undefined) {
            handleFilter(final);
        }
        setViewFilterModal(false);
        SetSuccessMessage('Filters applied Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        // handleFetchInvoices(final);
        return final;
    };

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    gst_start_date: '',
                    gst_end_date: '',
                    ar_start_date: '',
                    ar_end_date: '',
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    return (
        <div className="modal fade fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto" id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[470px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setViewFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[35%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow text-start w-full" role="presentation" onClick={() => setselectedType('gst_invoice_date')}>
                                    <a
                                        href="#pills-profileVertical"
                                        className={`nav-link block ${selectedType === 'gst_invoice_date' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-type"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pilltype"
                                        role="tab"
                                        aria-controls="pillcategorie"
                                        aria-selected="false"
                                    >
                                        GST Invoice Date
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start my-4 w-full" role="presentation" onClick={() => setselectedType('ar_date')}>
                                    <a
                                        href="#pills-profileareatotal"
                                        className={`nav-link ${selectedType === 'ar_date' ? 'active' : ''} block text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="Area-total"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-profileareatotal"
                                        role="tab"
                                        aria-controls="pills-profileareatotal"
                                        aria-selected="false"
                                    >
                                        AR Date
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[65%] h-[192px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div ref={dateRef} className={`tab-pane ${selectedType === 'gst_invoice_date' ? 'show active' : ''} fade px-3`} id="pills-type" role="tabpanel" aria-labelledby="pillcategorie">
                                    <div className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('gst_start_date')}

                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('gst_start_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="From date"
                                                    value={selected.gst_start_date === '' ? '' : moment(selected.gst_start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.gst_start_date && (
                                                <Calendar
                                                    value={moment(selected.gst_start_date).format('YYYY/MM/DD').gst_start_date}
                                                    onChange={(val) => handleDate(val, 'gst_start_date')}
                                                    placeholder="Date from"
                                                />

                                            )}
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('gst_end_date')}

                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('gst_end_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="To date"
                                                    value={selected.gst_end_date === '' ? '' : moment(selected.gst_end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.gst_end_date && (
                                                <Calendar
                                                    value={selected.gst_end_date}
                                                    onChange={(val) => handleDate(val, 'gst_end_date')}
                                                    minDate={moment(selected.gst_end_date).toDate()}
                                                    placeholder="Date to"
                                                />
                                            )}

                                        </div>
                                    </div>
                                </div>
                                <div ref={dateRef} className={`tab-pane ${selectedType === 'ar_date' ? 'show active' : ''} fade px-3`} id="pills-profileareatotal" role="tabpanel" aria-labelledby="Area-total">
                                    <div className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('ar_start_date')}

                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('ar_start_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="From date"
                                                    value={selected.ar_start_date === '' ? '' : moment(selected.ar_start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.ar_start_date && (
                                                <Calendar
                                                    value={moment(selected.ar_start_date).format('YYYY/MM/DD').ar_start_date}
                                                    onChange={(val) => handleDate(val, 'ar_start_date')}
                                                    placeholder="Date from"
                                                />
                                            )}
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('ar_end_date')}

                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('ar_end_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="To date"
                                                    value={selected.ar_end_date === '' ? '' : moment(selected.ar_end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.ar_end_date && (
                                                <Calendar
                                                    value={selected.ar_end_date}
                                                    onChange={(val) => handleDate(val, 'ar_end_date')}
                                                    minDate={moment(selected.ar_end_date).toDate()}
                                                    placeholder="Date to"
                                                />
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[35%] mr-5">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => generateUrl()}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewCustomerFilterModal;
